import {useCustomBreakpoint} from "../../../../../../scholastic-client-components/src/hooks/adaptive/useCustomBreakpoint"
import {REM_HOME_PAGE_BREAKPOINT} from "../constants"

export const useHomePageAdaptive = () => {
    const {inRange, innerWidth} = useCustomBreakpoint(REM_HOME_PAGE_BREAKPOINT)
    return {inRange, innerWidth, breakPoint: REM_HOME_PAGE_BREAKPOINT}
}
